import PhotoInput from '@/core/components/inputs/PhotoInput/PhotoInput';

export default PhotoInput;
